import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=9f9f9be8&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=9f9f9be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9f9be8",
  null
  
)

export default component.exports